// @core/api/endpoints/billing/delete_invoice_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/billing';

/**
 * Delete invoice numbering scheme
 * Deletes an invoice numbering scheme.
 */
export async function DeleteInvoiceNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoice-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
